var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 258,
    viewBox: "0 0 389 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_122",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 389,
    height: 258
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.86 88.86L310.78 110.79C319.787 119.79 324.38 128.61 324.56 137.25C324.74 145.89 320.973 154.07 313.26 161.79C305.547 169.503 297.37 173.27 288.73 173.09C280.09 172.91 271.27 168.313 262.27 159.3L240.27 137.3L202.79 174.79L228.33 200.34C244.13 216.127 260.21 226.507 276.57 231.48C292.93 236.453 308.32 236.87 322.74 232.73C337.327 228.503 350.574 220.581 361.2 209.73C373.333 197.59 381.42 184.173 385.46 169.48C389.5 154.787 388.857 139.453 383.53 123.48C378.197 107.48 367.813 91.7667 352.38 76.34L326.87 50.83L288.86 88.86ZM65.8601 25.16C51.2773 29.3893 38.0332 37.3116 27.4099 48.16C15.2832 60.3 7.19653 73.7167 3.14987 88.41C-0.896801 103.103 -0.253293 118.437 5.08004 134.41C10.1534 149.597 19.7866 164.54 33.9799 179.24L72.34 140.88C70.155 138.156 68.3019 135.182 66.82 132.02C65.1255 128.451 64.1891 124.569 64.07 120.62C63.89 111.953 67.6567 103.777 75.3701 96.09C83.0834 88.4033 91.2632 84.6367 99.9099 84.79C108.543 84.97 117.363 89.5633 126.37 98.57L148.37 120.57L185.85 83.09L160.3 57.54C144.5 41.74 128.42 31.3567 112.06 26.39C103.671 23.7646 94.9396 22.3964 86.1499 22.33C79.2986 22.3182 72.4793 23.264 65.8899 25.14M191.78 84.23L103.35 172.66L77.8501 147.16C77.3701 146.66 76.4101 145.61 75.6201 144.74L37.51 182.86L65.4299 210.86L112.56 258L171.06 199.49L199.28 171.28L236.76 133.78L269.5 101.05L285.32 85.3L323.32 47.3L276.06 0L191.78 84.23Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.53 -0.0200195H-0.870117V258.02H389.53V-0.0200195Z",
    fill: "url(#paint0_linear_1_122)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_122",
    x1: -39.1808,
    y1: 126.532,
    x2: 409.809,
    y2: 126.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1D6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9D3E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C469D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortous);
export default __webpack_public_path__ + "static/media/portous.288464d47a6471aa481781b441e9789b.svg";
export { ForwardRef as ReactComponent };